import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'iview/src/locale'
import iViewEn from 'iview/dist/locale/en-US'
import iViewZh from 'iview/dist/locale/zh-CN'
import iViewDe from 'iview/dist/locale/de-DE'
import en from '../locales/en'
import zn from '../locales/zh'
import de from '../locales/de'

Vue.use(VueI18n);

const messages = {
    en: Object.assign(en, iViewEn),
    zh: Object.assign(zn, iViewZh),
    de: Object.assign(de, iViewDe),
};
const lang = localStorage.getItem('locale') || 'zh';

const i18n = new VueI18n({
    locale:lang,
    messages
});

locale.i18n((key, value) => i18n.t(key, value));

export default i18n